export default {
  title: {
    id: 'bo_seller-options-batch_listing_creation-action_required_title',
    defaultMessage: 'Action required',
  },
  content: {
    id: 'bo_seller-options-batch_listing_creation-action_required_content_new',
    defaultMessage:
      'You chose item category {categoryName} for these listings of new items. The category_id is {categoryId}. Enter {categoryId} in the “category_id” column of your CSV file.',
  },
}
